export class InvalidTokenError extends Error {
  public message = '';

  public name = 'InvalidTokenError';

  public stack = '';
}
